import ReactDom from "react-dom";
import StuntDrivers from "./StuntDrivers.jsx";

export default function renderStuntDrivers() {
  document.querySelectorAll(".js-stuntdrivers-mount").forEach((mount) => {
    // checking data-model to exist is needed, if not JSON.parse("") will fail
    const data =
      mount.getAttribute("data-model") &&
      JSON.parse(mount.getAttribute("data-model"));

    ReactDom.render(<StuntDrivers {...data} />, mount);
  });
}
